import { ClientEventInput } from "../shared/interfaces";
import logger from "../services/loggerService";

/**
 * Parses supply chain tracking events from client input HTML element.
 *
 * This function retrieves and parses supply chain tracking event configurations from a DOM element.
 * The input is expected to be a JSON string containing event mappings where each key represents
 * an event code and the value contains event details (code and description).
 *
 * @param clientInput - The ID of the HTML element containing the JSON string
 * @returns Map<string, ClientEventInput> - A map of event codes to their configurations
 *
 * @example
 * // HTML element content example:
 * // {
 * //   "RECEIVED_AT_ORIGIN": {
 * //     "eventCode": "Package at Origin",
 * //     "eventDescription": "Package has been shipped from origin"
 * //   }
 * // }
 */
export default function parseSupplyChainTrackingEvents(clientInput: string): Map<string, ClientEventInput> {
    try {
        const element = document?.getElementById(clientInput) as HTMLInputElement;
        const jsonString = element?.value;

        const parsedObject = JSON.parse(jsonString);

        const resultMap = new Map<string, ClientEventInput>();

        for(const [key, value] of Object.entries(parsedObject)) {
            if(value) {
                resultMap.set(key, value as ClientEventInput);
            } else {
                logger.error("Invalid event structure for key");
            }
        }

        return resultMap;
    } catch (error) {
        logger.error("Failed to parse the input");
        return new Map<string, ClientEventInput>();
    }
}
